import { Inject, Injectable } from '@angular/core';

import { WchLoggerService } from '../../logger/wch.logger.service';
import { SdkMessageHandler, SdkMessageHandlerCallback } from './../../../../api';
import { createSubscribeRouteHandler } from './../../../../utils';
import { WchService } from './../../wch.service';

/* Copyright IBM Corp. 2018 */
const LOGGER = 'SdkSubscribeRouteHandler';


/**
 * Subscribes to a given route
 */
@Injectable()
export class SdkSubscribeRouteHandler implements SdkMessageHandler {

  handle: SdkMessageHandlerCallback;

  constructor(
    @Inject(WchService) wchService: WchService,
    @Inject(WchLoggerService) loggerService: WchLoggerService) {
    // construct the handler
    this.handle = createSubscribeRouteHandler(path => wchService.getRenderingContextByPath(path), loggerService.get(LOGGER));
  }
}
